import { render, staticRenderFns } from "./InlineCheckbox.vue?vue&type=template&id=fed356e4"
import script from "./InlineCheckbox.vue?vue&type=script&lang=js"
export * from "./InlineCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports